export const APP_STORE_URL = "https://apps.apple.com/us/app/pretup/id6757788101";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=fr.pretup.app.production";
